module.exports = __webpack_public_path__ + "img/zakelijk@2x.a96ef8f4.jpg";